module.exports = __webpack_public_path__ + "img/logo-shanrise.24e00cd4.png";